export const en = {
    "k_dc7f55f9": "Organizational structure",
    "k_5d911031": "Search user",
    "k_688d063": "Filtration",
    "k_b4b19a60": "Obtain user",
    "k_50e0cc3f": "User ID",
    "k_efc09635": "Please go to the role to manage this permission so that role members can obtain permission",
    "k_3ed94e02": "Determine whether a user belongs to a certain role",
    "k_712d3e6a": "Determine whether the current user belongs to a certain role, such as: w.isRoleMemberOf(\"role-id\")",
    "k_a0d527c3": "Role ID(for example,`\"role-id\"`)"
};
